import { Centred, Contents } from '../../styles/mixins'
const styles = theme => ({

  video: {
    width: '100%',
    objectFit: 'cover',
    height: '100%',
    zIndex: 0
  },
  indexVideoFallback: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    zIndex: '0'
  },
  videoInfo: {
    padding: theme.spacing.unit * 2,
    background: '#447589',
    '& p' : {
      color: '#fff',
      textAlign: 'center'
    }
  },
  videoInfoClosed: {
    height: 2,
    padding: 5,
    background: '#447589',
    overflowY: 'hidden'
  },
  inlineVideo: {
    '& video': {
      verticalAlign: 'middle'
    }
  },
  full: {
    margin: '0,0,0,0',
    objectFit: 'cover'
  },
  contents: {
    ...Contents(theme),
  },
  centred: {
    ...Centred(theme),
  },
  videospacing: {
    background: 'rgba(255,255,255,1)',
    fontSize: theme.typography.subheading.fontSize,
    background: 'rgba(255,255,255,1)',
    padding: '2rem 7rem 3rem 7rem',
    maxWidth: 1024,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/video/styles.js